export default __webpack_public_path__ + "static/richland-8a28b3b99542547dd2efc51429b3a10a.png";